import React, { useState, useEffect } from "react";
import ProjectBanner from "./components/ProjectBanner/ProjectBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const bustCache = (url) => `${url}?v=${Date.now()}`;

const ProjectsCard = () => {
  const [projects, setProjects] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const token = localStorage.getItem("token");
        const email = localStorage.getItem("userEmail");
        if (!token || !email) return;

        // fetch owned projects
        const ownedRes = await fetch(`${BACKEND_URL}/projects/user/${email}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const ownedData = await ownedRes.json();

        // fetch collaborations
        const memberRes = await fetch(`${BACKEND_URL}/projects/user/${email}/member`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const memberData = await memberRes.json();

        // merge results
        const owned = ownedRes.ok ? ownedData.projects || [] : [];
        const member = memberRes.ok ? memberData.projects || [] : [];

        const combined = [
            ...owned.map((p) => ({
                ...p,
                image: bustCache(p.image),
                isOwner: true,
                isMember: true, // owner is also a member
            })),
            ...member.map((p) => ({
                ...p,
                image: bustCache(p.image),
                isOwner: false,
                isMember: true,
            })),
        ];


        setProjects(combined);
      } catch (err) {
        console.error("❌ Error fetching projects:", err);
      }
    };

    fetchProjects();
  }, []);

  // Always show at most 3 unless expanded
  const visibleProjects = expanded ? projects : projects.slice(0, 3);

  return (
    <div
      className={`w-full max-w-[652px] bg-white rounded-2xl shadow-sm p-6 flex flex-col transition-all duration-300`}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Projects</h2>
      </div>

      {/* Body with project banners */}
      <div className="space-y-3">
        {projects.length > 0 ? (
          visibleProjects.map((project) => (
            <ProjectBanner
              key={project.id}
              project={project}
              type={project.isOwner ? "creations" : "contributions"}
            />
          ))
        ) : (
          <p className="text-gray-400 text-center mt-6">No projects yet</p>
        )}
      </div>

      {/* Footer */}
      {projects.length > 3 && (
        <div className="mt-4 text-right">
          <button
            onClick={() => setExpanded((prev) => !prev)}
            className="text-xs font-medium text-gray-600 hover:underline"
          >
            {expanded ? "View Less" : "View More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProjectsCard;
